import { LoanProductCategory } from '@ilg-totallymoney/types'

import { getCategoryPathForId } from './getCategoryPathForId'

/**
 * For unscored journeys, we want to use / as the alias
 * for the /all-cards route.
 *
 * @param category - The loan category
 * @returns The unscored category path
 */
export function getUnscoredCategoryPath(category: LoanProductCategory) {
    const isPersonal = category === 'PersonalLoan'

    return isPersonal ? '' : getCategoryPathForId(category)
}
